import { AlertTheme } from '../types';
import { typography } from '../constants/typography';
import { neutralColors, colors } from '../constants/colors';

export const alert: AlertTheme = {
  alert: {
    customVariant: { color: colors.jlMoneyOrangeBright, iconName: 'triangle-exclamation' },
    borderLeft: `4px solid ${colors.jlMoneyOrangeBright}`,
    fontWeight: typography.weights.semiBold,
    background: colors.jlMoneyPinkLight,
    icon: colors.jlMoneyOrangeBright,
    padding: '16px 12px 16px 12px',
    text: colors.jlMoneyGreenDark,
    borderRadius: '0 6px 6px 0',
    marginRight: '16px',
    border: 'none',
  },
  warning: {
    customVariant: { iconName: 'circle-exclamation', color: colors.jlMoneyAmber },
    borderLeft: `4px solid ${colors.jlMoneyAmber}`,
    fontWeight: typography.weights.semiBold,
    background: colors.jlMoneyOrangeLight,
    padding: '16px 12px 16px 12px',
    text: colors.jlMoneyGreenDark,
    borderRadius: '0 6px 6px 0',
    icon: colors.jlMoneyAmber,
    marginRight: '16px',
    border: 'none',
  },
  info: {
    customVariant: { color: colors.jlMoneyBlue, iconName: 'info-circle' },
    borderLeft: `4px solid ${colors.jlMoneyBlue}`,
    fontWeight: typography.weights.semiBold,
    background: colors.jlMoneyBlueLight,
    padding: '16px 12px 16px 12px',
    text: colors.jlMoneyGreenDark,
    borderRadius: '0 6px 6px 0',
    icon: colors.jlMoneyBlue,
    marginRight: '16px',
    border: 'none',
  },
  success: {
    //TBA design needed
    customVariant: { iconName: 'circle-exclamation', color: colors.jlMoneyAmber },
    border: `1px solid ${colors.successDark}`,
    fontWeight: typography.weights.semiBold,
    background: neutralColors.white,
    padding: '8px 12px 16px 12px',
    borderRadius: '0 6px 6px 0',
    text: colors.successDark,
    icon: colors.success,
    marginRight: '12px',
  },
  brand: {
    //TBA design needed
    customVariant: { iconName: 'circle-exclamation', color: colors.jlBlack },
    fontWeight: typography.weights.semiBold,
    background: neutralColors.white,
    padding: '8px 12px 16px 12px',
    borderRadius: '0 6px 6px 0',
    text: colors.greyDarkest,
    marginRight: '12px',
    icon: colors.brand,
    border: 'none',
  },
};
